import $ from 'jquery';
import Cookie from 'js-cookie';

let cookie = Cookie.get( 'notice-understood' );

if ( ! cookie || cookie == 'false' ) {
  $( '#notice-modal' ).modal( {
    'backdrop': 'static'
  } ).modal( 'show' );

  $( '#notice-understood' ).on( 'change', function ( e ) {
    if ( $( e.target ).is( ':checked' ) ) {
      $( '#notice-close' ).removeAttr( 'disabled' ).focus();
      Cookie.set( 'notice-understood', 'true' );
    } else {
      $( '#notice-close' ).attr( 'disabled', true );
      Cookie.set( 'notice-understood', 'false' );
    }
  } );
}
